module.exports = __webpack_public_path__ + "img/list.be6f68b4.svg";